<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.nuevo}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                     [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                     [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion"
                     [pagination]="true"
                     [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [innTemplate]="abrirModal"
                [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModal>
  <div class="container-fluid">
    <form [formGroup]="agregarForm" mat-dialog-content>
      <div class="row">
        <div class="col-lg-6">
          <div class="row">
            <div class="col-lg-12 mb-2">
              <label for="ordenbalanza">Orden Balanza</label>
              <input class="form-control" formControlName="ordenbalanza" id="ordenbalanza" type="text">
              <small *ngIf="agregarForm.controls['ordenbalanza'].errors && agregarForm.controls['ordenbalanza'].touched"
                     class="text-danger">*Este campo es inválido</small>
            </div>

            <div class="col-lg-12 mb-2">
              <label for="autoriza">Autoriza</label>
              <select class="form-control" formControlName="autoriza">
                <option value="">-- Seleccione --</option>
                <option value="0">Si</option>
                <option value="1">No</option>
              </select>
              <small *ngIf="agregarForm.controls['autoriza'].errors && agregarForm.controls['autoriza'].touched"
                     class="text-danger">*Este campo es inválido</small>
            </div>

            <!-- AGREGAR DIRECTIVA 4 DIGITOS -->
            <div class="col-lg-12 mb-2">
              <label for="difAcidez">Dif. Acidez</label>
              <input appFourDigitDecimalNumber class="form-control" formControlName="difAcidez" id="difAcidez"
                     placeholder="12.1234" type="text">
              <small *ngIf="agregarForm.controls['difAcidez'].errors && agregarForm.controls['difAcidez'].touched"
                     class="text-danger">*Este campo es inválido</small>
            </div>

            <div class="col-lg-12 mb-2">
              <label for="usuarioAutoriza">Usuario Autoriza</label>
              <input class="form-control" formControlName="usuarioAutoriza" id="usuarioAutoriza"
                     placeholder="Máximo 10 caracteres" type="text">
              <small
                *ngIf="agregarForm.controls['usuarioAutoriza'].errors && agregarForm.controls['usuarioAutoriza'].touched"
                class="text-danger">*Este campo es inválido</small>
            </div>

            <div class="col-lg-12 mb-2">
              <label for="usuarioCaptura">Usuario Captura</label>
              <input class="form-control" formControlName="usuarioCaptura" id="usuarioCaptura" type="text">
              <small
                *ngIf="agregarForm.controls['usuarioCaptura'].errors && agregarForm.controls['usuarioCaptura'].touched"
                class="text-danger">*Este campo es inválido</small>
            </div>

            <div class="col-lg-12 mb-2">
              <label for="difHumedadimp">Dif. Humedad Imp.</label>
              <input appFourDigitDecimalNumber class="form-control" formControlName="difHumedadimp" id="difHumedadimp"
                     placeholder="12.1234" type="text">
              <small
                *ngIf="agregarForm.controls['difHumedadimp'].errors && agregarForm.controls['difHumedadimp'].touched"
                class="text-danger">*Este campo es inválido</small>
            </div>

            <div class="col-lg-12 mb-2">
              <label for="loteInspeccion">Lote de Insp.</label>
              <input class="form-control" formControlName="loteInspeccion" id="loteInspeccion" type="text">
              <small
                *ngIf="agregarForm.controls['loteInspeccion'].errors && agregarForm.controls['loteInspeccion'].touched"
                class="text-danger">*Este campo es inválido</small>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="col-lg-12 mb-2">
            <label for="proveedor">Proveedor</label>
            <input class="form-control" formControlName="proveedor" id="proveedor" type="text">
            <small *ngIf="agregarForm.controls['proveedor'].errors && agregarForm.controls['proveedor'].touched"
                   class="text-danger">*Este campo es inválido</small>
          </div>

          <div class="col-lg-12 mb-2">
            <label for="material">Material</label>
            <input class="form-control" formControlName="material" id="material" type="text">
            <small *ngIf="agregarForm.controls['material'].errors && agregarForm.controls['material'].touched"
                   class="text-danger">*Este campo es inválido</small>
          </div>

          <div class="col-lg-12 mb-2">
            <label for="horaAuth">Hora Autorización</label>
            <input class="form-control" formControlName="horaAuth" id="horaAuth" type="text">
            <small *ngIf="agregarForm.controls['horaAuth'].errors && agregarForm.controls['horaAuth'].touched"
                   class="text-danger">*Este campo es inválido</small>
          </div>

          <div class="col-lg-12 mb-2">
            <label for="fechaAuth">Fecha Autorización</label>
            <input class="form-control" formControlName="fechaAuth" id="fechaAuth" type="text">
            <small *ngIf="agregarForm.controls['fechaAuth'].errors && agregarForm.controls['fechaAuth'].touched"
                   class="text-danger">*Este campo es inválido</small>
          </div>

          <div class="col-lg-12 mb-2">
            <label for="fechaHoraCaptura">Fecha Hora Captura</label>
            <input class="form-control" formControlName="fechaHoraCaptura" id="fechaHoraCaptura" type="text">
            <small
              *ngIf="agregarForm.controls['fechaHoraCaptura'].errors && agregarForm.controls['fechaHoraCaptura'].touched"
              class="text-danger">*Este campo es inválido</small>
          </div>

          <div class="col-lg-12 mb-2">
            <label for="analista">Analista</label>
            <input class="form-control" formControlName="analista" id="analista" placeholder="Máximo 10 caracteres"
                   type="text">
            <small *ngIf="agregarForm.controls['analista'].errors && agregarForm.controls['analista'].touched"
                   class="text-danger">*Este campo es inválido</small>
          </div>
        </div>
      </div>
      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [formularioValido]="agregarForm.invalid"
                                   [loading]="loading" [textBoton]="'Guardar'" class="row">
      </app-lfsa-botones-formulario>
    </form>
  </div>
</ng-template>
<!-- END MODAL -->
